import { createGlobalSelectors } from '../commons/Redux/selector'
import * as sessionSelectors from '../commons/SessionReducer/reducer'
import { dynamicReducer } from './reducer'

const rootKeyPath = dynamicReducer.getRootKeyPath()

export const session = createGlobalSelectors(rootKeyPath, 'session', null)
export const test = createGlobalSelectors(rootKeyPath, 'test', null)
export const userInfo = createGlobalSelectors(rootKeyPath, 'user-info', sessionSelectors)